import { DeviceCustomerDetail } from './../../types/customer-detail';
import { ActionType } from '../../types';
import { GatewayListData } from '../../types/gateway';
import { DeviceListData } from '../../types/device';
import { LuminaryListData } from '../../types/luminary';
import { SLADataList, SLAListData } from '../../types/sla';
import { slaCustomerList } from '../../types/sla-customer-details';
import { MaintenanceTicketDetailListData } from '../../types/maintenance-ticket';
import { FirePanelListData } from '../../types/firepanel';
import { WhiteListDetail, WhitelistZoneData } from '../../state/assets-state';
import { ConfigureLuminaryDetailsList } from '../../types/configure-luminaries-list-types';
import { GetIOConfigDetailsOkResponse, SetIOConfigurationOkResponse } from '../../api/types';

export const AssetActions = {
    deviceListStarted: () =>
    ({
        type: 'Asset/deviceList/Started',
    } as const),

    deviceListSucceeded: (deviceList: DeviceListData) =>
    ({
        type: 'Asset/deviceList/Succeeded',
        payload: { deviceList }
    } as const),

    deviceListFailed: (errorCode: string) =>
    ({
        type: 'Asset/deviceList/Failed',
        payload: { errorCode },
    } as const),

    deviceListUnmounted: () =>
    ({
        type: 'Asset/deviceList/Unmounted',
    } as const),

    whitelistzoneStarted: () =>
    ({
        type: 'Asset/whitelistzone/Started',
    } as const),

    whitelistzoneSucceeded: (id: string, message: string) =>
    ({
        type: 'Asset/whitelistzone/Succeeded',
        payload: { id, message }
    } as const),

    whitelistzoneFailed: (errorCode: string) =>
    ({
        type: 'Asset/whitelistzone/Failed',
        payload: { errorCode },
    } as const),

    whitelistzoneUnmounted: () =>
    ({
        type: 'Asset/whitelistzone/Unmounted',
    } as const),

    getWhitelistZoneStarted: () =>
    ({
        type: 'Asset/getDeviceWhitelistZoneData/Started',
    } as const),

    getWhitelistZoneSucceeded: (whitelistZoneData: WhitelistZoneData) =>
    ({
        type: 'Asset/getDeviceWhitelistZoneData/Succeeded',
        payload: { whitelistZoneData }
    } as const),

    getWhitelistZoneFailed: (errorCode: string) =>
    ({
        type: 'Asset/getDeviceWhitelistZoneData/Failed',
        payload: { errorCode },
    } as const),

    getWhitelistZoneUnmounted: () =>
    ({
        type: 'Asset/getDeviceWhitelistZoneData/Unmounted',
    } as const),

    getWhitelistDetailStarted: () =>
    ({
        type: 'Asset/getDeviceWhitelistDetail/Started',
    } as const),

    getWhitelistDetailSucceeded: (whitelistDetail: WhiteListDetail[]) =>
    ({
        type: 'Asset/getDeviceWhitelistDetail/Succeeded',
        payload: { whitelistDetail }
    } as const),

    getWhitelistDetailFailed: (errorCode: string) =>
    ({
        type: 'Asset/getDeviceWhitelistDetail/Failed',
        payload: { errorCode },
    } as const),

    getWhitelistDetailUnmounted: () =>
    ({
        type: 'Asset/getDeviceWhitelistDetail/Unmounted',
    } as const),

    deviceCustomerDataStarted: () =>
    ({
        type: 'Customer/deviceCustomerData/Started',
    } as const),

    deviceCustomerDataSucceeded: (customerData: DeviceCustomerDetail) =>
    ({
        type: 'Customer/deviceCustomerData/Succeeded',
        payload: { customerData }
    } as const),

    deviceCustomerDataFailed: (errorCode: string) =>
    ({
        type: 'Customer/deviceCustomerData/Failed',
        payload: { errorCode },
    } as const),

    deviceCustomerDataUnmounted: () =>
    ({
        type: 'Customer/deviceCustomerData/Unmounted',
    } as const),

    updateCustomerStarted: () =>
    ({
        type: 'Customer/updateCustomerDetail/Started',
    } as const),

    updateCustomerSucceeded: (id: string) =>
    ({
        type: 'Customer/updateCustomerDetail/Succeeded',
        payload: { id },
    } as const),

    updateCustomerFailed: (errorCode: string) =>
    ({
        type: 'Customer/updateCustomerDetail/Failed',
        payload: { errorCode },
    } as const),

    updateCustomerUnmounted: () =>
    ({
        type: 'Customer/updateCustomerDetail/Unmounted',
    } as const),

    luminaryListStarted: () =>
    ({
        type: 'Asset/luminaryList/Started',
    } as const),

    luminaryListSucceeded: (luminaryListData: LuminaryListData) =>
    ({
        type: 'Asset/luminaryList/Succeeded',
        payload: { luminaryListData }
    } as const),

    luminaryListFailed: (errorCode: string) =>
    ({
        type: 'Asset/luminaryList/Failed',
        payload: { errorCode },
    } as const),

    luminaryListUnmounted: () =>
    ({
        type: 'Asset/luminaryList/Unmounted',
    } as const),

    gatewayDetailsListStarted: () =>
    ({
        type: 'Asset/gatewayDetailsList/Started',
    } as const),

    gatewayDetailsListSucceeded: (gatewayDetailsList: GatewayListData) =>
    ({
        type: 'Asset/gatewayDetailsList/Succeeded',
        payload: { gatewayDetailsList }
    } as const),

    gatewayDetailsListFailed: (errorCode: string) =>
    ({
        type: 'Asset/gatewayDetailsList/Failed',
        payload: { errorCode },
    } as const),

    gatewayDetailsListUnmounted: () =>
    ({
        type: 'Asset/gatewayDetailsList/Unmounted',
    } as const),

    slaListStarted: () =>
    ({
        type: 'Asset/slaList/Started',
    } as const),

    slaListSucceeded: (SLADetailsList: SLAListData) =>
    ({
        type: 'Asset/slaList/Succeeded',
        payload: { SLADetailsList }
    } as const),

    slaListFailed: (errorCode: string) =>
    ({
        type: 'Asset/slaList/Failed',
        payload: { errorCode },
    } as const),

    slaListUnmounted: () =>
    ({
        type: 'Asset/slaList/Unmounted',
    } as const),

    maintenanceTicketListStarted: () =>
    ({
        type: 'Asset/maintenanceTicketList/Started',
    } as const),

    maintenanceTicketListSucceeded: (MaintenanceTicketDetailListData: MaintenanceTicketDetailListData) =>
    ({
        type: 'Asset/maintenanceTicketList/Succeeded',
        payload: { MaintenanceTicketDetailListData }
    } as const),

    maintenanceTicketListFailed: (errorCode: string) =>
    ({
        type: 'Asset/maintenanceTicketList/Failed',
        payload: { errorCode },
    } as const),

    maintenanceTicketListUnmounted: () =>
    ({
        type: 'Asset/maintenanceTicketList/Unmounted',
    } as const),

    slaDetailsListStarted: () =>
    ({
        type: 'Asset/slaDetailsList/Started',
    } as const),

    slaDetailsListSucceeded: (slaDetailsList: SLADataList) =>
    ({
        type: 'Asset/slaDetailsList/Succeeded',
        payload: { slaDetailsList }
    } as const),

    slaDetailsListFailed: (errorCode: string) =>
    ({
        type: 'Asset/slaDetailsList/Failed',
        payload: { errorCode },
    } as const),

    slaDetailsListUnmounted: () =>
    ({
        type: 'Asset/slaDetailsList/Unmounted',
    } as const),

    slaCustomerListStarted: () =>
    ({
        type: 'Asset/slaCustomerDetails/Started',
    } as const),

    slaCustomerListSucceeded: (customerDetailsList: slaCustomerList) =>
    ({
        type: 'Asset/slaCustomerDetails/Succeeded',
        payload: { customerDetailsList }
    } as const),

    slaCustomerListFailed: (errorCode: string) =>
    ({
        type: 'Asset/slaCustomerDetails/Failed',
        payload: { errorCode },
    } as const),

    slaCustomerListUnmounted: () =>
    ({
        type: 'Asset/slaCustomerDetails/Unmounted',
    } as const),

    firePanelListStarted: () =>
    ({
        type: 'Asset/firePanelList/Started',
    } as const),

    firePanelListSucceeded: (firePanelList: FirePanelListData) =>
    ({
        type: 'Asset/firePanelList/Succeeded',
        payload: { firePanelList }
    } as const),

    firePanelListFailed: (errorCode: string) =>
    ({
        type: 'Asset/firePanelList/Failed',
        payload: { errorCode },
    } as const),

    firePanelListUnmounted: () =>
    ({
        type: 'Asset/firePanelList/Unmounted',
    } as const),

    configureLuminairesListStarted: () =>
    ({
        type: 'Asset/configureLuminairesList/Started',
    } as const),

    configureLuminairesListSucceeded: (configLumnList: ConfigureLuminaryDetailsList) =>
    ({
        type: 'Asset/configureLuminairesList/Succeeded',
        payload: { configLumnList }
    } as const),

    configureLuminairesListFailed: (errorCode: string) => ({
        type: 'Asset/configureLuminairesList/Failed',
        payload: { errorCode },
    } as const),

    configureLuminairesListUnmounted: () =>
    ({
        type: 'Asset/configureLuminairesList/Unmounted',
    } as const),

    setConfigureLuminairesListStarted: () =>
    ({
        type: 'Asset/setConfigureLuminairesList/Started',
    } as const),

    setConfigureLuminairesListSucceeded: (message: string) =>
    ({
        type: 'Asset/setConfigureLuminairesList/Succeeded',
        payload: { message }
    } as const),

    setConfigureLuminairesListFailed: (errorCode: string) => ({
        type: 'Asset/setConfigureLuminairesList/Failed',
        payload: { errorCode },
    } as const),

    setConfigureLuminairesListUnmounted: () =>
    ({
        type: 'Asset/setConfigureLuminairesList/Unmounted',
    } as const),

    getIoConfigDetailsStarted: () =>
    ({
        type: 'Asset/getIoConfigDetails/Started',
    } as const),

    getIoConfigDetailsSucceeded: (configIoDetails: GetIOConfigDetailsOkResponse) =>
    ({
        type: 'Asset/getIoConfigDetails/Succeeded',
        payload: { configIoDetails }
    } as const),

    getIoConfigDetailsFailed: (errorCode: string) => ({
        type: 'Asset/getIoConfigDetails/Failed',
        payload: { errorCode },
    } as const),

    getIoConfigDetailsUnmounted: () =>
    ({
        type: 'Asset/getIoConfigDetails/Unmounted',
    } as const),

    setIOConfigurationStarted: () =>
    ({
        type: 'Asset/setIOConfiguration/Started',
    } as const),

    setIOConfigurationSucceeded: (message: string) =>
    ({
        type: 'Asset/setIOConfiguration/Succeeded',
        payload: { message }
    } as const),

    setIOConfigurationFailed: (errorCode: string) => ({
        type: 'Asset/setIOConfiguration/Failed',
        payload: { errorCode },
    } as const),

    setIOConfigurationUnmounted: () =>
    ({
        type: 'Asset/setIOConfiguration/Unmounted',
    } as const),

};

export type AssetAction = ActionType<typeof AssetActions>;
